import React, { useEffect, useRef, useState } from 'react';
import {
   Box,
   Grid,
   Paper,
   Typography,
   IconButton,
   Button,
   Radio,
   Switch,
   Backdrop,
   Modal,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Input } from '../../../assets/styled/Element';
import 'react-nice-dates/build/style.css';
import { TitleLabel } from '../../Element/LabelInputForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import { useSnackbar } from 'notistack';
import Axios from 'axios';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import LoadingPopup from '../../Loading/LoadingPopup';

import InformationPage from './InfomationPage';
import QuestionPage from './QuestionPage';

import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom';

import ErrorPopup from '../../Error/ErrorPopup';
import Delete from './component/Delete';

const useStyles = makeStyles((theme) => ({
   backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
   },
   paper: {
      width: '80%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
      backgroundColor: '#F2F4FA',
   },
   paperDark: {
      width: '80%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
      backgroundColor: '#424242',
   },
   header: {
      padding: theme.spacing(2, 4, 3),
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   title_name: {
      backgroundColor: 'white',
      padding: theme.spacing(2, 4, 2),
      marginBottom: '20px',
   },
   category: {
      backgroundColor: 'white',
      padding: theme.spacing(2, 4, 0),
      margin: '0 24px 30px',
      borderRadius: '0 0 8px 8px',
      fontFamily: 'DBHeavent',
      fontSize: '20px',
   },
   activeLineCategory: {
      height: '5px',
      width: '150px',
      backgroundColor: '#ed008a',
   },
   inActivelineCategory: {
      height: '5px',
      width: '150px',
   },
   require: {
      display: 'inline-block',
      color: 'red',
      marginLeft: '3px',
   },
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
}));

const Create = (props) => {
   const classes = useStyles();
   const closeRef = useRef();
   const theme = useTheme();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const history = useHistory();

   const [isLoading, setIsLoading] = useState(false);

   const [isError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });

   const queryParams = new URLSearchParams(window.location.search);
   const surveyGroupId = queryParams.get('SurveyGroupId');

   const [myModal, setMyModal] = useState('');
   const [showModal, setShowModal] = useState(false);

   const [surveyDetailData, setSurveyDetailData] = useState(null);

   const [surveyName, setSurveyName] = useState(() => {
      const timestamp = dayjs().format('DD-MM-YYYY HH:mm:ss');
      return {
         nameTh: `แบบทดสอบ ${timestamp}`,
         nameEn: `Survey ${timestamp}`,
      };
   });

   const [activeCategory, setActiveCategory] = useState('information');

   const [formInformation, setFormInformation] = useState({});

   const [formQuestionDetail, setFormQuestionDetail] = useState();

   const handleSurveyNameChange = (event) => {
      const { name, value } = event.target;
      setSurveyName((prevData) => ({
         ...prevData,
         [name]: value,
      }));
   };

   const validateFormDefault = () => {
      if (
         surveyName.nameTh &&
         surveyName.nameEn &&
         formInformation.coverImage &&
         formInformation.typeReward &&
         formInformation.OwnerOrgEmployeeId &&
         formInformation.startDate &&
         formInformation.endDate
      ) {
         return validateLocation();
      } else {
         return false;
      }
   };

   const validateTypeForm = () => {
      if (formInformation.typeReward == 'no_reward') {
         return true;
      } else if (formInformation.typeReward == 'point') {
         if (
            formInformation.rule.ruleId &&
            (formInformation.initialPoints ||
               formInformation.initialPoints == 0) &&
            (formInformation.privilegePoint.governance ||
               formInformation.privilegePoint.governance == 0) &&
            (formInformation.privilegePoint.digitalization ||
               formInformation.privilegePoint.digitalization == 0) &&
            (formInformation.privilegePoint.society ||
               formInformation.privilegePoint.society == 0)
            // &&formInformation.limitPoint.isLimitPoint
         ) {
            return true;
         } else return false;
      } else if (formInformation.typeReward == 'reward') {
         if (
            formInformation.reward.rewardId
            // && formInformation.limitPoint.isLimitPoint
         ) {
            return true;
         } else return false;
      }
   };

   const validateLocation = () => {
      if (formInformation.useLocation) {
         if (Number(formInformation.useLocationMode) === 1) {
            return !!formInformation.location;
         }
         if (Number(formInformation.useLocationMode) === 2) {
            const { latitude, longitude } = formInformation;

            const sixDecimalOrIntegerRegex = /(^-?\d+$)|(^-?\d+\.\d{6,}$)/;

            return (
               sixDecimalOrIntegerRegex.test(latitude) &&
               sixDecimalOrIntegerRegex.test(longitude)
            );
         }
         // useLocation is true, but mode is not 1 or 2.
         return false;
      }
      return true;
   };

   const handleCategoryClick = (category) => {
      if (validateFormDefault() && validateTypeForm()) {
         if (category == 'question') {
            onNext();
            // setActiveCategory(category);
         } else {
            editQuestion(surveyGroupId, payloadQuestion);
            setActiveCategory(category);
         }
      }
   };

   const onBack = async () => {
      if (activeCategory === 'information') {
         await closeCreate();
      } else if (activeCategory === 'question') {
         await onSave();
         setActiveCategory('information');
      }
   };

   //################ Information Page ################
   const handleFormInformation = (data) => {
      setFormInformation(() => ({
         ...data,
      }));
   };
   //##############################################

   const payloadInformation = async (
      typeReward,
      formInformation,
      surveyName,
   ) => {
      const processAllowList = (originalList, updatedList) => {
         const additions = updatedList
            .filter(
               (item) =>
                  !originalList.some(
                     (orig) =>
                        orig.divisionId === item.divisionId &&
                        orig.surveyAllowListId === item.surveyAllowListId,
                  ),
            )
            .map((item) => ({
               SurveyAllowListId: 0,
               DivisionId: item.divisionId,
            }));

         const deletions = originalList
            .filter(
               (orig) =>
                  !updatedList.some(
                     (item) =>
                        orig.divisionId === item.divisionId &&
                        orig.surveyAllowListId === item.surveyAllowListId,
                  ),
            )
            .map((orig) => ({
               SurveyAllowListId: orig.surveyAllowListId,
               DivisionId: orig.divisionId,
            }));

         return [...additions, ...deletions];
      };

      const initialWhiteLits =
         surveyDetailData?.allowList.whiteList?.map((item) => ({
            divisionId: item.divisionId,
            surveyAllowListId: item.surveyAllowListId,
         })) || [];

      const initialBlackLits =
         surveyDetailData?.allowList.blackList?.map((item) => ({
            divisionId: item.divisionId,
            surveyAllowListId: item.surveyAllowListId,
         })) || [];

      const basePayload = {
         ...(surveyDetailData?.surveyGroup.surveyGroupId && {
            SurveyGroupId: surveyDetailData.surveyGroup.surveyGroupId,
         }),
         SurveyNameTh: surveyName.nameTh || '',
         SurveyNameEn: surveyName.nameEn || '',
         ImageUrl: formInformation.coverImage,

         SurveySubNameTh: formInformation.nameTitleSurvey || '',
         SurveySubNameEn: formInformation.nameTitleSurvey || '',
         SurveyDescTh: formInformation.descSurvey || '',
         SurveyDescEn: formInformation.descSurvey || '',
         IsParticipateLimit:
            formInformation.limitRespondent.isLimitRespondent || false,
         ParticipateLimit: formInformation.limitRespondent.limitRespondent || 0,
         OwnerOrgEmployeeId: formInformation.OwnerOrgEmployeeId,
         ...(surveyGroupId
            ? {
                 WhiteList: processAllowList(
                    initialWhiteLits,
                    formInformation.whiteListDivisions,
                 ),
                 BlackList: processAllowList(
                    initialBlackLits,
                    formInformation.blackListDivisions,
                 ),
              }
            : {
                 WhiteList: formInformation.whiteListDivisions,
                 BlackList: formInformation.blackListDivisions,
              }),
         status: formInformation.isActive ? 1 : 2,
         ValidFrom:
            dayjs(formInformation.startDate).format('YYYY-MM-DDTHH:mm:ss') ||
            '',
         ValidThrough:
            dayjs(formInformation.endDate).format('YYYY-MM-DDTHH:mm:ss') || '',
         DeliveryType: formInformation.deliveryType,
         isDisplay: formInformation.isDisplay,
         useLocation: formInformation.useLocation,
         useLocationMode: Number(formInformation.useLocationMode),
         venueTh:
            formInformation.location &&
            Number(formInformation.useLocationMode) === 1 &&
            formInformation.location.name
               ? formInformation.location.name
               : null,
         venueEn:
            formInformation.location &&
            Number(formInformation.useLocationMode) === 1 &&
            formInformation.location.name
               ? formInformation.location.name
               : null,

         latitude: Number(formInformation.latitude)
            ? Number(formInformation.latitude)
            : null,
         longitude: Number(formInformation.longitude)
            ? Number(formInformation.longitude)
            : null,
      };

      if (typeReward === 'point') {
         basePayload.RewardType = 1;
         basePayload.TypePoint = {
            RuleId: formInformation.rule.ruleId || null,
            InitialPoints: formInformation.initialPoints || 0,
            GPoint: formInformation.privilegePoint.governance || 0,
            SPoint: formInformation.privilegePoint.digitalization || 0,
            BPoint: formInformation.privilegePoint.society || 0,
            IsPointLimit: formInformation.limitPoint.isLimitPoint || false,
            GPointLimit: formInformation.permissionLimit.governance || 0,
            SPointLimit: formInformation.permissionLimit.digitalization || 0,
            BPointLimit: formInformation.permissionLimit.society || 0,
         };
      } else if (typeReward === 'reward') {
         basePayload.RewardType = 2;
         basePayload.TypeReward = {
            RewardId: formInformation.reward.rewardId || 0,
            RewardText: formInformation.namePrivilege || '',
            IsRewardLimit: formInformation.limitPoint.isLimitPoint || false,
            RewardLimit: formInformation.limitPoint.limitPoint || 0,
         };
      } else {
         basePayload.RewardType = 0;
      }

      return basePayload;
   };

   const transformKeys = (data) => {
      if (!Array.isArray(data)) {
         return []; // คืนค่าเป็นอาร์เรย์เปล่าเพื่อป้องกันข้อผิดพลาด
      }

      return data.map(({ seq, nextStepDesc, surveyGroupId, ...section }) => ({
         SectionId: section.sectionId || 0,
         SecNameTh: section.secNameTh || '',
         SecNameEn: section.secNameEn || '',
         SecDescTh: section.secDescTh || '',
         SecDescEn: section.secDescEn || '',
         NextStepType: section.nextStepType || 0,
         NextSectionId: section.nextSectionId || 0,
         IsBreakPage: section.isBreakPage,
         IsDelete: section.isDelete || false,
         Question:
            section.question?.map(({ seq, nextStepDesc, ...question }) => ({
               QuestionId: question.questionId || 0,
               QuesNameTh: question.quesNameTh || '',
               QuesNameEn: question.quesNameEn || '',
               QuesDescTh: question.quesDescTh || '',
               QuesDescEn: question.quesDescEn || '',
               InputType: question.inputType || 0,
               ChoiceMode: question.choiceMode || 0,
               QuesImageURL: question.quesImageURL || '',
               IsRequired: question.isRequired || false,
               NextStepType: question.nextStepType || 0,
               NextSectionId: question.nextSectionId || 0,
               NextQuestionId: question.nextQuestionId || 0,
               AnswerMin: question.answerMin || 0,
               AnswerMax: question.answerMax || 0,
               IsDelete: question.isDelete || false,
               Options:
                  question.option?.map(({ seq, nextStepDesc, ...option }) => ({
                     OptionId: option.optionId || 0,
                     OptionTh: option.optionTh || '',
                     OptionEn: option.optionEn || '',
                     OptionImageUrl: option.optionImageUrl || '',
                     NextStepType: option.nextStepType || 0,
                     NextSectionId: option.next_SectionId || 0,
                     NextQuestionId: option.next_QuestionId || 0,
                     IsDelete: option.isDelete || false,
                  })) || [],
            })) || [],
      }));
   };

   // ใช้ฟังก์ชันแปลงข้อมูล formQuestionDetail โดยตัด Seq และ NextStepDesc ออก
   const transformedData = transformKeys(formQuestionDetail || []);

   // สร้าง payloadQuestion ด้วยข้อมูลที่แปลงแล้ว
   const payloadQuestion = {
      SurveyGroupId: surveyDetailData?.surveyGroup?.surveyGroupId ?? 0,
      Section: transformedData,
   };

   const handleEditQuestion = (updatedValue) => {
      const payloadQuestion = {
         SurveyGroupId: surveyDetailData?.surveyGroup?.surveyGroupId ?? 0,
         Section: transformKeys(updatedValue),
      };

      editQuestion(surveyGroupId, payloadQuestion);
   };

   const onSave = async () => {
      const payload = await payloadInformation(
         formInformation.typeReward,
         formInformation,
         surveyName,
      );
      //ตอนอยู่หน้า Information
      if (activeCategory === 'information') {
         //กดบันทึกตอนที่สร้าง survey แล้ว
         if (surveyGroupId) {
            editSurvey(payload);
         }
         //กดบันทึกตอนยังไม่เคยสร้าง survey
         else {
            createSurvey(payload, 'save');
         }
      }
      //ตอนอยู่หน้า Question
      else if (activeCategory === 'question') {
         editQuestion(surveyGroupId, payloadQuestion);
      }
   };

   const onNext = async () => {
      const payload = await payloadInformation(
         formInformation.typeReward,
         formInformation,
         surveyName,
      );

      //ตอนอยู่หน้า Question
      if (activeCategory == 'question') {
         //กด next จะ edit แล้วกดปิด popup
         editQuestion(surveyGroupId, { ...payloadQuestion, IsPublish: true });
         closeCreate();
      }
      //ตอนอยู่หน้า Information
      else {
         //ถ้าสร้าง survey แล้วจะ edit แล้วไปหน้า question ต่อ
         if (surveyGroupId) {
            editSurvey(payload);
            setActiveCategory('question');
         }
         //ถ้าไม่เคยสร้าง survey แล้วจะ create แล้วไปหน้า question ต่อ
         else {
            await createSurvey(payload, 'next');
            // await setActiveCategory("question");
         }
      }
   };

   const createSurvey = async (values, from) => {
      setIsLoading(true);

      try {
         const resp = await Axios.post(
            '/GSB/dashboard/survey/CreateSurvey',
            values,
         );
         enqueueSnackbar('สร้างรายการสำเร็จ!!', { variant: 'success' });

         await getSurveyDetail(resp.data.surveyGroupId);

         history.push(
            `/private/survey?SurveyGroupId=${resp.data.surveyGroupId}`,
         );

         await createQuestion(resp.data.surveyGroupId);
      } catch (e) {
         LogToBackend(e);
         if (e.response) {
            const response = e.response.data;
            enqueueSnackbar(response.errorAppMessageTh, { variant: 'error' });
         } else {
            console.error('site error');
         }
      } finally {
         sessionStorage.removeItem('value');
         setIsLoading(false);
         if (from == 'next') {
            setActiveCategory('question');
         }
      }
   };

   const editSurvey = (values) => {
      setIsLoading(true);

      Axios.post('/GSB/dashboard/survey/EditSurvey', values)
         .then((resp) => {
            enqueueSnackbar('แก้ไขรายการสำเร็จ!!', {
               variant: 'success',
            });
            getSurveyDetail(surveyDetailData.surveyGroup.surveyGroupId);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            sessionStorage.removeItem('value');
            setIsLoading(false);
         });
   };

   const createQuestion = async (surveyGroupId) => {
      const payloadQuestion = {
         SurveyGroupId: surveyGroupId,
         SecNameTh: 'Section Name',
         SecNameEn: 'Section Name',
         SecDescTh: '',
         SecDescEn: '',
         Question: {
            QuesNameTh: 'Question Name',
            QuesNameEn: 'Question Name',
            QuesDescTh: '',
            QuesDescEn: '',
            InputType: 1,
            ChoiceMode: 1,
            IsRequired: false,
            Options: [
               {
                  OptionTh: 'choice',
                  OptionEn: 'choice',
               },
            ],
         },
      };

      setIsLoading(true);

      Axios.post('/GSB/dashboard/survey/CreateQuestion', payloadQuestion)
         .then((resp) => {
            // enqueueSnackbar("สร้างรายการสำเร็จ!!", {
            //   variant: "success",
            // });

            getSurveyDetail(surveyGroupId);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            sessionStorage.removeItem('value');
            setIsLoading(false);
         });
   };

   const editQuestion = async (surveyGroupId, payloadQuestion) => {
      setIsLoading(true);
      await Axios.post('/GSB/dashboard/survey/EditQuestion', payloadQuestion)
         .then((resp) => {
            enqueueSnackbar('แก้ไขรายการสำเร็จ!!', {
               variant: 'success',
            });
            getSurveyDetail(surveyGroupId);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            sessionStorage.removeItem('value');
            setIsLoading(false);
         });
   };

   const editDeleteSection = async (data) => {
      const payloadSection = {
         SurveyGroupId: surveyGroupId,
         SectionId: data.sectionId,
      };

      setIsLoading(true);
      Axios.delete('/GSB/dashboard/survey/DeleteSection', {
         headers: {
            Accept: 'application/json',
         },
         data: payloadSection,
      })
         .then((resp) => {
            // enqueueSnackbar("ลบรายการสำเร็จ!!", {
            //   variant: "success",
            // });
            getSurveyDetail(surveyGroupId);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');

            console.error(
               'Error details:',
               e.response ? e.response.data : e.message,
            );
         })
         .finally(() => {
            sessionStorage.removeItem('value');
            setIsLoading(false);
         });
   };

   const getSurveyDetail = async (SurveyId) => {
      setIsLoading(true);

      Axios.get('/GSB/dashboard/survey/GetSurveyDetail', {
         params: { SurveyGroupId: SurveyId },
      })
         .then((resp) => {
            if (resp.data) {
               setSurveyDetailData(resp.data);
               setFormQuestionDetail(resp.data.section);

               setSurveyName({
                  nameTh: resp.data.surveyGroup.surveyNameTh || '',
                  nameEn: resp.data.surveyGroup.surveyNameEn || '',
               });
            }
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            sessionStorage.removeItem('value');
            setIsLoading(false);
         });
   };

   const closeCreate = async () => {
      props.onClickClose();
      history.push('/private/survey');
      props.onSuccess();
   };

   const handleRemoveQuestion = (data) => {
      setModalStyle(data);
   };

   const setModalStyle = (data) => {
      setMyModal(
         <Delete
            onClickClose={() => setShowModal(false)}
            data={data}
            type={'section'}
            onSuccess={() => {
               editDeleteSection(data);
               setShowModal(false);
            }}
         />,
      );

      setShowModal(!showModal);
   };

   useEffect(() => {
      if (surveyGroupId) {
         getSurveyDetail(surveyGroupId);
      }
   }, [surveyGroupId]);

   useEffect(() => {
      if (props.edit) {
         history.push(`/private/survey?SurveyGroupId=${props.edit}`);
         getSurveyDetail(props.edit);
      }
   }, []);

   //##################################################################

   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );

   return (
      <Paper
         className={
            theme.palette.type === 'light' ? classes.paper : classes.paperDark
         }
      >
         <Backdrop className={classes.backdrop} open={isLoading}>
            <LoadingPopup />
         </Backdrop>

         <Modal className={classes.modal} open={showModal}>
            <React.Fragment>{myModal}</React.Fragment>
         </Modal>

         <Box>
            {/* เพิ่มแบบทดสอบ และ ปุ่มปิด */}
            <div className={classes.header}>
               <Typography variant={'h4'}>แบบสอบถาม</Typography>
               <IconButton
                  className={classes.headerL}
                  size={'small'}
                  onClick={closeCreate}
                  ref={closeRef}
               >
                  <FontAwesomeIcon icon={faTimesCircle} />
               </IconButton>
            </div>

            {/* ชื่อแบบทดสอบภาษาไทยและ อังกฤษ */}
            <div className={classes.title_name}>
               <Box display={'flex'} alignItems={'center'} width={'100%'}>
                  <Box
                     width={'100%'}
                     display={'flex'}
                     alignItems={'flex-end'}
                     gridGap={'5px'}
                  >
                     <Box
                        display={'flex'}
                        flexDirection={'column'}
                        width={'100%'}
                        color={'black'}
                     >
                        <TitleLabel Fs={'20px'}>
                           ชื่อแบบทดสอบ
                           <div className={classes.require}>*</div>
                        </TitleLabel>
                        <Input
                           name={'nameTh'}
                           placeholder={'ชื่อแบบทดสอบภาษาไทย'}
                           value={surveyName.nameTh}
                           onChange={handleSurveyNameChange}
                        />
                     </Box>
                     <Box
                        display={'flex'}
                        flexDirection={'column'}
                        width={'100%'}
                     >
                        <Input
                           name={'nameEn'}
                           placeholder={'ชื่อแบบทดสอบภาษาอังกฤษ'}
                           value={surveyName.nameEn}
                           onChange={handleSurveyNameChange}
                        />
                     </Box>
                  </Box>

                  <Box
                     width={'100%'}
                     display={'flex'}
                     justifyContent={'flex-end'}
                     gridGap={'3px'}
                  >
                     <Button
                        variant={'outlined'}
                        style={{
                           border: '1px solid #707070',
                           color: '#707070',
                           padding: '5px 15px',
                           height: '41px',
                        }}
                        size='medium'
                        onClick={onBack}
                     >
                        ย้อนกลับ
                     </Button>

                     <Button
                        variant={'outlined'}
                        style={{
                           border: '1px solid #27A844',
                           color: '#27A844',
                           padding: '5px 15px',
                           height: '41px',
                        }}
                        disabled={
                           !(validateFormDefault() && validateTypeForm())
                        }
                        onClick={onSave}
                     >
                        บันทึก
                     </Button>

                     <Button
                        variant={'contained'}
                        style={{
                           backgroundColor: '#ed008a',
                           color: '#ffffff',
                           height: '41px',
                           boxShadow: 'none',
                        }}
                        disabled={
                           !(validateFormDefault() && validateTypeForm())
                        }
                        onClick={onNext}
                     >
                        {activeCategory === 'information' ? 'ต่อไป' : 'เผยแพร่'}
                     </Button>
                  </Box>
               </Box>
            </div>
            {/* Category infomation และ question */}
            <div className={classes.category}>
               <Box display={'flex'}>
                  <Box
                     display={'flex'}
                     flexDirection={'column'}
                     alignItems={'center'}
                     onClick={() => handleCategoryClick('information')}
                     style={{ cursor: 'pointer' }}
                  >
                     <Box
                        color={
                           theme.palette.type === 'dark' ? 'black' : 'black'
                        }
                     >
                        Information
                     </Box>
                     <div
                        className={
                           activeCategory === 'information'
                              ? classes.activeLineCategory
                              : classes.inActivelineCategory
                        }
                     ></div>
                  </Box>

                  <Box
                     display={'flex'}
                     flexDirection={'column'}
                     alignItems={'center'}
                     onClick={() => handleCategoryClick('question')}
                     style={{
                        cursor:
                           validateFormDefault() && validateTypeForm()
                              ? 'pointer'
                              : 'not-allowed',
                     }}
                  >
                     <Box
                        color={
                           validateFormDefault() && validateTypeForm()
                              ? 'black'
                              : theme.palette.type === 'dark'
                              ? 'black'
                              : '#e7e7e7'
                        }
                     >
                        Question
                     </Box>
                     <div
                        className={
                           activeCategory === 'question'
                              ? classes.activeLineCategory
                              : classes.inActivelineCategory
                        }
                     ></div>
                  </Box>
               </Box>
            </div>
            {activeCategory === 'information' && (
               <InformationPage
                  onInformationData={handleFormInformation}
                  onDetailSurveyData={surveyDetailData}
               />
            )}
            {activeCategory === 'question' && (
               <QuestionPage
                  value={formQuestionDetail}
                  onValueChange={setFormQuestionDetail}
                  onActionTriggerAdd={handleEditQuestion}
                  onDeleteSection={handleRemoveQuestion}
               />
            )}
         </Box>
      </Paper>
   );
};

export default Create;
